import { Component, OnInit, HostListener, ViewChild, ElementRef,Renderer2,AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { EnvService } from '../../core/env.service';
import { ShareService } from '../../commonservices/shared.service';

declare var $: any;

import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss']
})
export class FullComponent implements OnInit {

  @ViewChild('navToggle', { static: false }) navToggle: ElementRef; 

  public config: PerfectScrollbarConfigInterface = {};
  public globalSettings: any = null;

  clicked: boolean = false;

  constructor(public router: Router,private _envi: EnvService, private _sharedService: ShareService, private changeDetectorRef: ChangeDetectorRef,
    private renderer: Renderer2) {

    // this.renderer.listen('window', 'click',(e:Event)=>{
    //     if(e.target === this.navToggle.nativeElement ){
    //         this.clicked = true;
    //     }
    // });

  }

  
  public copyright  = new Date().getFullYear();

  closeMenu: boolean = false;


  tabStatus = 'justified';

  public isCollapsed = false;

  public innerWidth: any;
  public defaultSidebar: any;
  public showSettings = false;
  public showMobileMenu = false;
  public expandLogo = false;
  sideBarMenu:any;
  newInvoice: boolean = false;
  isfixed:any = null;
  options = {
    theme: 'light',               // two possible values: light, dark
    dir: 'ltr',                   // two possible values: ltr, rtl
    layout: 'vertical',           // fixed value. shouldn't be changed.
    sidebartype: 'full',          // four possible values: full, iconbar, overlay, mini-sidebar
    sidebarpos: 'fixed',          // two possible values: fixed, absolute
    headerpos: 'fixed',           // two possible values: fixed, absolute
    boxed: 'full',                // two possible values: full, boxed
    navbarbg: 'skin6',            // six possible values: skin(1/2/3/4/5/6)
    sidebarbg: 'skin5',           // six possible values: skin(1/2/3/4/5/6)
    logobg: 'skin6',              // six possible values: skin(1/2/3/4/5/6)
  };

  haederNavIsFixed:boolean = false;
  Logo() {
    this.expandLogo = !this.expandLogo;
  }
  isFullSideBar:boolean = false;

  optionsEventChange(data: any){

    //debugger;
    this.isfixed = data.sidebarpos;
    this.isClickOutSide = false;
   //this.options.sidebartype = 'mini-sidebar';
      this.options = data;
      if(this.isfixed === 'fixed')
      {
        this.options.sidebartype = 'full';
        this.isFullSideBar = true;
        this.haederNavIsFixed = true;
        let element = document.getElementById('nav-icon1')
        if(element != null){
          element.classList.add('open');
        }
      }
      this.changeDetectorRef.detectChanges();
  }
 
  ngOnInit() {
    if (this.router.url === '/') {
      this.router.navigate([this._envi.defaultLandingPage]);
    }
    this.defaultSidebar = this.options.sidebartype;
    this.handleSidebar();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    // this.handleSidebar();
  }

  showMenuClick(e)
  {
    this.sideBarMenu = e;
    if(this.isfixed === 'fixed')
    {
      this.isFullSideBar = true;
      this.options.sidebartype = 'full';
      this.isClickOutSide = false;
    }
    else{
      if(this.sideBarMenu === 'Rules')
      {
        this.isFullSideBar = false;
        this.options.sidebartype = 'full';
        this.isClickOutSide = false;
      }
      else{
        this.options.sidebartype = 'mini-sidebar';
      this.isFullSideBar = true;
      this.haederNavIsFixed = false;
      let element = document.getElementById('nav-icon1')
      element.classList.remove('open'); 
 
      }
    }  
  }

  settings(data: any){
    this.globalSettings = data;
  }

  handleSidebar() {
    // this.innerWidth = window.innerWidth;
    // switch (this.defaultSidebar) {
    //   case 'full':
    //   case 'iconbar':
    //     if (this.innerWidth < 1170) {
    //       this.options.sidebartype = 'mini-sidebar';
    //     } else {
    //       this.options.sidebartype = this.defaultSidebar;
    //     }
    //     break;

    //   case 'overlay':
    //     if (this.innerWidth < 767) {
    //       this.options.sidebartype = 'mini-sidebar';
    //     } else {
    //       this.options.sidebartype = this.defaultSidebar;
    //     }
    //     break;

    //   default:
    // }
  }
  isFixedAndClosable:boolean = false;

  isClickOutSide:boolean;

  toggleSidebarType() {
    //debugger;
    //  let element = document.getElementById('nav-icon1')

    if(this.isfixed == 'absolute')
    {      
      let element = document.getElementById('nav-icon1')
      console.log(element.className);
      if(element.className == 'open' )
      {
        this.options.sidebartype = 'mini-sidebar';
        element.classList.remove('open');

      }
      else
      {
        element.classList.add('open');
        console.log(element.className);
        this.options.sidebartype = 'full';
      }
    }
     
    
    if(this.isfixed == 'fixed')
    {
      let element = document.getElementById('nav-icon1')
      if(element.className == 'open' )
      {
        this.options.sidebartype = 'mini-sidebar';
        this.isFullSideBar = true;
        this.haederNavIsFixed = true;
        let element = document.getElementById('nav-icon1')
        element.classList.remove('open'); 
        this.isfixed = '';
      }
      else
      {

      }
    }
    else if(this.isfixed == '' )
    {
      this.options.sidebartype = 'full';
      this.isFullSideBar = true;
      this.haederNavIsFixed = true;
      let element = document.getElementById('nav-icon1')
      element.classList.add('open'); 
      this.isfixed = 'fixed';
    }
  }

  onClickOutside()
  {
    if(this.isfixed == 'absolute')
    {
      let element = document.getElementById('nav-icon1')
      console.log(element.className);
      if(element.className == 'open' )
      {
        this.options.sidebartype = 'mini-sidebar';
        element.classList.remove('open'); 
      }
    }
  }

  newInvoiceGrid(data){
    this._sharedService.emitOnSearchListNext(data);
  }
}